import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiArrowRight } from 'react-icons/fi';

import vixPeekingSide from '../../assets/Vix/vix_pointer.webp';

export const PORTFOLIO_BUBBLE_KEY = 'vissory_portfolio_bubble_v1';

/**
 * VixFloatingBubble
 *
 * Floating bottom-right hint bubble. Appears after the onboarding tour
 * completes for creatives without any portfolio images uploaded yet.
 * Vix lives inside the bubble at the bottom-left, pointing toward the CTA.
 *
 * Props:
 *   userId          – used for the localStorage dismiss key
 *   onGoToProfile   – callback: navigates to the profile tab and triggers the portfolio spotlight
 */
const BUBBLE_TEXT = {
  creative: '¡Sube tu primer proyecto y sé más visible para las marcas!',
  creator:  '¡Completa tu perfil para encontrar creativos y ser descubierto por marcas!',
  brand:    '¡Completa tu perfil de empresa para atraer a los mejores creativos!',
};

const VixFloatingBubble = ({ userId, role, onGoToProfile }) => {
  const [visible, setVisible] = useState(true);

  const handleDismiss = () => {
    try { localStorage.setItem(`${PORTFOLIO_BUBBLE_KEY}_${userId}`, '1'); } catch (_) {}
    setVisible(false);
  };

  const handleClick = () => {
    handleDismiss();
    onGoToProfile();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="vix-bubble-root"
          initial={{ opacity: 0, y: 40, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.85 }}
          transition={{ duration: 0.35, ease: 'easeOut', delay: 0.4 }}
          role="complementary"
          aria-label="Sugerencia de Vix"
        >
          <button
            type="button"
            className="vix-bubble-close"
            onClick={handleDismiss}
            aria-label="Cerrar sugerencia"
          >
            <FiX />
          </button>

          <div className="vix-bubble-card">
            <p className="vix-bubble-text">
              {BUBBLE_TEXT[role] || BUBBLE_TEXT.creative}
            </p>

            {/* Bottom row: Vix pointing at the CTA button */}
            <div className="vix-bubble-bottom">
              <img
                src={vixPeekingSide}
                alt=""
                className="vix-bubble-mascot-img"
                aria-hidden="true"
              />
              <button
                type="button"
                className="vix-bubble-cta"
                onClick={handleClick}
              >
                {role === 'creative' ? 'Ir a Portfolio' : 'Ir a Perfil'} <FiArrowRight className="vix-bubble-cta-arrow" />
              </button>
            </div>

            {/* Bubble tail — bottom-right */}
            <span className="vix-bubble-tail" aria-hidden="true" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VixFloatingBubble;
